<template>
<main>
  <header>
    <img src="http://dimg02.c-ctrip.com/images/10031e000001fq0hcB1E3.jpg" alt=""/>
    <hotelSearch class="search" :hasHotelType="true" @change="changeSearch"/>
  </header>
  <el-carousel class="banner">
    <el-carousel-item v-for="item in ad.banners" :key="item.img">
      <router-link :to="item.url" class="banner_item">
        <img :src="item.img" :title="item.title" :alt="item.title"/>
        <p>
          <span>{{item.title}}</span>
          <span class="price">{{item.min_price}}</span>
        </p>
      </router-link>
    </el-carousel-item>
  </el-carousel>
  <section class="recommend">
      <h2>热门酒店</h2>
      <!-- <nav>
        <a 
          :class="{on: i === 0}" 
          v-for="(v, i) in 6" :key="i">测试文案</a>
      </nav> -->
      <ul>
        <template v-for="v in ad.hots">
          <li :key="v.url">
            <router-link :to="v.url">
              <img :src="v.img" alt=""/>
              <figure>
                <p>{{v.title}}</p>
                <b>{{v.min_price}}起</b>
              </figure>
            </router-link>
          </li>
        </template>
      </ul>
    </section>
</main>
</template>

<script>
import moment from 'moment';
import hotelSearch from '@components/hotel_search';
import $hotel from '@api/hotel';
export default {
  components: {
    hotelSearch
  },
  data () {
    return {
      visible: false,
      search: {

      },
      ad: {},
      pickerOptions: {
        disabledDate (date) {
          const diff = moment().diff(date, 'd');
          return diff > 0;
        }
      }
    }
  },
  created () {
    this.getAd();
  },
  methods: {
    async getAd () {
      const ad = await $hotel.ad();
      this.ad = ad;
    },
    changeSearch (data) {
      this.$router.push({name: 'hotel_list', query: {data: JSON.stringify(data)}});
    }
  }
}
</script>

<style scoped src="./index.css"> </style>